let getCartHandler = async () => {
	let res = await fetch('/?section_id=cart-drawer');
	let text = await res.text();
	document.getElementById('shopify-section-cart-drawer').innerHTML = text;
	cartToggleHandler();
	let button = document.querySelector('.add-to-cart');
	button.setAttribute('value', 'Add to Cart');
	button.classList.remove('disabled');
	button.removeAttribute('disabled');

	setQuantityDecreaseButtonsEventListener();
	setQuantityIncreaseButtonsEventListener();
	setOverlayEventListener();
	setCloseIconEventListener();
};

let updateCartHandler = () => {
	getCartHandler();
};

let quantityDecreaseButtonClickHandler = (key, quantity) => {
	var formData = new FormData();
	formData.append(`updates[${key}]`, parseInt(quantity) - 1);

	fetch(window.Shopify.routes.root + 'cart/update.js', {
		method: 'POST',
		body: formData,
	})
		.then((response) => response.json())
		.then(() => {
			updateCartHandler();
		});
};
let quantityIncreaseButtonClickHandler = (key, quantity) => {
	var formData = new FormData();
	if (parseInt(quantity) < 40) {
		formData.append(`updates[${key}]`, parseInt(quantity) + 1);
		fetch(window.Shopify.routes.root + 'cart/update.js', {
			method: 'POST',
			body: formData,
		})
			.then((response) => response.json())
			.then((response) => console.log(response))
			.then(() => {
				updateCartHandler();
			});
	} else {
		alert('40 insoles is the max!');
	}
};

let cartToggleHandler = () => {
	let cartDrawer = document.getElementById('cart-drawer');
	let cartOverlay = document.getElementById('cart-drawer-overlay');
	let cartUpsaleMessages = Array.from(document.getElementsByClassName('cart-upsale-message'));
	cartUpsaleMessages.forEach((message) => {
		message.classList.toggle('animate__headShake');
	});
	cartOverlay.classList.toggle('open');
	cartDrawer.classList.toggle('open');
};

let setQuantityDecreaseButtonsEventListener = () => {
	let quantityDecreaseButtons = Array.from(document.getElementsByClassName('quantity-decrease-button'));
	quantityDecreaseButtons.forEach((button) => {
		button.addEventListener('click', () => {
			quantityDecreaseButtonClickHandler(
				button.getAttribute('data-type-key'),
				button.getAttribute('data-type-quantity')
			);
		});
	});
};

let setQuantityIncreaseButtonsEventListener = () => {
	let quantityIncreaseButtons = Array.from(document.getElementsByClassName('quantity-increase-button'));
	quantityIncreaseButtons.forEach((button) => {
		button.addEventListener('click', () => {
			quantityIncreaseButtonClickHandler(
				button.getAttribute('data-type-key'),
				button.getAttribute('data-type-quantity')
			);
		});
	});
};

let setCloseIconEventListener = () => {
	let icon = document.getElementById('cart-close');
	icon.addEventListener('click', () => cartToggleHandler());
};

let setOverlayEventListener = () => {
	let cartDrawerOverlay = document.getElementById('cart-drawer-overlay');
	cartDrawerOverlay.addEventListener('click', () => cartToggleHandler());
};
setQuantityDecreaseButtonsEventListener();
setQuantityIncreaseButtonsEventListener();
setCloseIconEventListener();
setOverlayEventListener();
